export default () => {
  const data = {
    event_name: 'click',
    button_name: 'close_modal',
    page_section: 'modal_talk_with',
    name_of_the_page_viewed: 'search_personal',
  };
  return data;
};
